import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { AppDatepickerComponent } from '@ui-kit/app-datepicker/app-datepicker.component';
import { OnlyNumbersDirectiveModule } from '@ui-kit/directives/only-numbers/only-numbers.module';
import { OutsideClickModule } from '@ui-kit/directives/outside-click/outside-click.module';

@NgModule({
  imports: [
    MatDatepickerModule,
    ReactiveFormsModule,
    MatIconModule,
    CommonModule,
    TranslateUiModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    OnlyNumbersDirectiveModule,
    MatMenuModule,
    OutsideClickModule
  ],
  declarations: [AppDatepickerComponent],
  exports: [AppDatepickerComponent]
})
export class AppDatepickerModule {}
